/**
 * Emails that match backend `app.super-admin.emails` (comma-separated) and/or default bootstrap admin.
 */
const DEFAULT_SUPER_ADMIN_EMAILS = ['admin@crudexpert.com'];

function parseEmailsFromEnv(): string[] {
  const raw = process.env.REACT_APP_SUPER_ADMIN_EMAILS?.trim();
  if (!raw) return [];
  return raw.split(',').map((e) => e.trim().toLowerCase()).filter(Boolean);
}

export function getSuperAdminEmails(): string[] {
  const fromEnv = parseEmailsFromEnv();
  if (fromEnv.length > 0) {
    return Array.from(new Set([...fromEnv, ...DEFAULT_SUPER_ADMIN_EMAILS.map((e) => e.toLowerCase())]));
  }
  return DEFAULT_SUPER_ADMIN_EMAILS.map((e) => e.toLowerCase());
}

export function isSuperAdminUser(user: { email?: string } | null | undefined): boolean {
  if (!user?.email) return false;
  const normalized = user.email.trim().toLowerCase();
  return getSuperAdminEmails().includes(normalized);
}

/** Host/subdomain slug for the super-admin entry URL (e.g. super-admin.localhost). Not an organization in the DB. */
export const SUPER_ADMIN_TENANT_SLUG = 'super-admin';

export function isSuperAdminTenantSlug(slug: string | null | undefined): boolean {
  return !!slug && slug.toLowerCase() === SUPER_ADMIN_TENANT_SLUG;
}

export const SUPER_ADMIN_ACTIVITY_HOME = '/super-admin/activity-logs';
